import { Observable } from 'rxjs';
import { ServiceType } from 'src/app/core/constants/service-type.constant';
import {
  IIncodeStatusResponseApi,
  ILoginIncodeResponse,
} from '../../interfaces/incode.interface';
import {
  ClientInfoResponse,
  Compatibility,
  DnValidation,
  IContractBody,
  IContractResponse,
  IDn,
  IInfoClientAvailableCredit,
  IResponseAvailableCredit,
  IResponseDnProfile,
  IResponseSaveInfoClient,
  ISaveClientInfo,
  ISaveSignature,
  IValidationDnTypeService,
  IZipCode,
  OtpResponse,
  OtpResponseValidation
} from '../../interfaces/validations.interface';

export abstract class ValidationsServiceBase {
  abstract ValidateDn(dn: DnValidation): Observable<OtpResponse>;

  abstract validateOtp(
    code: string,
    idDn: string,
    imei: string,
  ): Observable<OtpResponseValidation>;

  abstract checkCompatibility(imei: string): Observable<Compatibility>;

  abstract validateOtpPortability(
    code: string,
    idDn: string,
  ): Observable<OtpResponseValidation>;

  abstract validateDnType(dn: string): Observable<IValidationDnTypeService>;

  abstract getClientInfo(sessionId: string): Observable<ClientInfoResponse>;

  abstract getColony(colony: string): Observable<IZipCode>;

  abstract profileDn(value: IDn, type: string): Observable<IResponseDnProfile>;

  abstract saveClientInfo(
    dataClient: ISaveClientInfo,
  ): Observable<IResponseSaveInfoClient>;

  abstract saveClientPortabilityInfo(
    dataClient: ISaveClientInfo,
  ): Observable<IResponseSaveInfoClient>;

  abstract getOffersAvailableCredit(
    code: string,
    idDn: string,
    clientInfo: IInfoClientAvailableCredit,
    classification: string,
  ): Observable<IResponseAvailableCredit>;

  abstract getInfoContract(
    offer: IContractBody,
    uuidPreregister: string,
  ): Observable<IContractResponse>;

  abstract saveLegalsSignature(
    signature: ISaveSignature,
    uuid: string,
  ): Observable<unknown>;

  abstract viewPortability(uuidContract: string): Observable<unknown>;

  abstract getValidateStepIncode(
    sessionId: string,
    token: string,
  ): Observable<IIncodeStatusResponseApi>;

  abstract loginIncode(): Observable<ILoginIncodeResponse>;

  abstract noPaymentContract(uuidContract: string, typeService: ServiceType): Observable<unknown>;
}
